import { createApp } from 'vue';
import PortalApp from './PortalApp.vue3.vue';
import store, { key } from './store';

import router from './config/portalRouter';
import i18n from './config/i18n';
import './config/portalAxios';
import chartjsConfig from './config/chartjs';
import primeVueConfig from './config/primevue';
import componentsConfig from './config/components';
import * as filters from './config/filters';

// Import add-to-calendar-button
import "add-to-calendar-button";

const app = createApp(PortalApp);

// Configure Chart.js
chartjsConfig(app);

// Configure PrimeVue
primeVueConfig(app);

// Configure components
componentsConfig(app);

// Configure for custom elements
app.config.compilerOptions.isCustomElement = (tag: string) => tag === 'add-to-calendar-button';

// Add global properties for filters
app.config.globalProperties.$filters = {
    formatShortDate: filters.formatShortDate,
    formatShortDateTime: filters.formatShortDateTime,
    formatTimeSince: filters.formatTimeSince
};

app.use(store, key)
    .use(router)
    .use(i18n)
    .mount('#app');
